import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import type { StateData } from '@/lib/become-an-agent-types';
import { highlightFacts } from '@/lib/highlight-facts';

export function StateFAQ({ state }: { state: StateData }) {
    const faqs = state.faqs ?? [];
    const [openIdx, setOpenIdx] = useState<number | null>(0);

    if (faqs.length === 0) return null;

    return (
        <section id="faq" className="scroll-mt-20 bg-[#F5F5F5]">
            <div className="mx-auto max-w-3xl px-6 py-20 sm:py-24 lg:py-28">
                <h2 className="font-didot mb-10 text-3xl text-[#0b2222] sm:text-4xl">
                    Frequently asked questions about becoming a travel agent in {state.state}
                </h2>
                <ul className="divide-y divide-[#0b2222]/10">
                    {faqs.map((faq, i) => (
                        <li key={i} className="py-5">
                            <button
                                type="button"
                                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                                className="flex w-full items-center justify-between gap-4 text-left"
                                aria-expanded={openIdx === i}
                            >
                                <span className="font-didot text-xl text-[#0b2222]">{faq.question}</span>
                                <ChevronDown
                                    className={`h-5 w-5 shrink-0 text-[#0b2222]/60 transition-transform ${
                                        openIdx === i ? 'rotate-180' : ''
                                    }`}
                                />
                            </button>
                            {openIdx === i && (
                                <p className="mt-3 text-base leading-relaxed text-[#0e2727]">{highlightFacts(faq.answer)}</p>
                            )}
                        </li>
                    ))}
                </ul>
                <div className="mt-12 text-center">
                    <a
                        href="/become-an-agent"
                        className="lux-caps lux-caps-sm inline-block rounded-sm border border-[#0e2727] bg-[#0b2222] px-4 py-1.5 text-[#E8E0D8] transition hover:bg-[#0e2727]"
                    >
                        Apply now
                    </a>
                </div>
            </div>
        </section>
    );
}
